import { render, staticRenderFns } from "./ShareDocument.vue?vue&type=template&id=3564c572&scoped=true&"
import script from "./ShareDocument.vue?vue&type=script&lang=js&"
export * from "./ShareDocument.vue?vue&type=script&lang=js&"
import style0 from "./ShareDocument.vue?vue&type=style&index=0&id=3564c572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564c572",
  null
  
)

export default component.exports